import request from "@/utils/request";
// 根据userToken获取用户头像昵称
export function getSlideshow(params) {
  return request({
    url: "/ework2/weike/weikeAd/adImgs",
    method: "get",
    params,
  });
}
export function getcurriculum(params) {
  return request({
    url: "/ework2/weike/weikeClass/getGroupClassList",
    method: "get",
    params,
  });
}

export function getcurriculumbark(params) {
  return request({
    url: "/ework2/weike/weikeClass/classListV2",
    method: "get",
    params,
  });
}
// 我的课程
export function getInfo(params) {
  return request({
    url: "/ework2/weike/weikeClass/myInfo",
    method: "get",
    params,
  });
}
// 我的课程 new
export function pageMyClassGroupList(params) {
  return request({
    url: "/ework2/weike/classGroup/pageMyClassGroupList",
    method: "get",
    params,
  });
}

// 添加订阅消息
export function subscribe(params) {
  return request({
    url: "/ework2/weike/weikeClass/subscribe",
    method: "get",
    params,
  });
}

// 获取templateId
export function getSubscribeTmpId(params) {
  return request({
    url: "/ework2/weike/weikeClass/getSubscribeTmpId",
    method: "get",
    params,
  });
}
// 课程积分排行榜
export function getRank(params) {
  return request({
    url: "/ework2/weike/weikeUser/classRankList",
    method: "get",
    params,
  });
}

//  课程小节
export function sectionList(params) {
  return request({
    url: "/ework2/weike/weikeClass/sectionList",
    method: "get",
    params,
  });
}
// 评论点赞
export function commentStar(data) {
  return request({
    url: "/ework2/weike/weikeUserCommentStar/commentStar",
    method: "post",

    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: data,
  });
}

// 保存用户小节完成 new
export function sectionComplete(params) {
  return request({
    url: "/ework2/weike/weikeClass/sectionComplete",
    method: "get",
    params,
  });
}

// 获取课程详情
export function getchapter(params) {
  return request({
    url: "/ework2/weike/weikeClass/classInfo",
    method: "get",
    params,
  });
}

// 加入课程组
export function joinClassGroup(params) {
  return request({
    url: "/ework2/weike/classGroup/joinClassGroup",
    method: "get",
    params,
  });
}
// 获取证书数
export function getUserStatistics(params) {
  return request({
    url: "/ework2/weike/weikeUser/getUserStatistics",
    method: "get",
    params,
  });
}
//加入课程
export function joincurriculum(data) {
  return request({
    url: "/ework2/weike/weikeClass/joinClass",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: data,
  });
}

export function getclassSearch(params) {
  return request({
    url: "/ework2/weike/weikeClass/classSearchV2",
    method: "get",
    params,
  });
}
//  小节
export function sectionInfo(params) {
  return request({
    url: "/ework2/weike/weikeClass/sectionInfo",
    method: "get",
    params,
  });
}
// 添加弹幕评论 //php
export function getinsertForumComment(data) {
  return request({
    url: "/ework2/weike/weikeUserComment/submitComment",
    method: "post",

    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: data,
  });
}

// 查询视频弹幕
export function getcomment(params) {
  return request({
    url: "/ework2/weike/weikeUserComment/classCommentList",
    method: "get",
    params,
  });
}

// 小节点赞
export function addBizForum(data) {
  return request({
    url: "/ework2/weike/weikeUserStar/submitStar",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: data,
  });
}
// 查询用户点赞头像列表

export function getWXDZTX(params) {
  return request({
    url: "/ework2/weike/weikeUserStar/getStar",
    method: "get",
    params,
  });
}
// 获取班级
export function getSchoolClass(params) {
  return request({
    url: "/ework2/weike/schoolClass/list",
    method: "get",
    params,
  });
}
// 获取班级详情
export function getClassGroupDetail(classGroupId) {
  return request({
    url: `/ework2/weike/classGroup/detail/${classGroupId}`,
    method: "get",
  });
}
//   获取我是否点过赞
export function isStar(params) {
  return request({
    url: "/ework2/weike/weikeUserStar/isStar",
    method: "get",
    params,
  });
}
export function getGroup(params) {
  return request({
    url: "/ework2/weike/classGroup/list",
    method: "get",
    params,
  });
}

// 课程购买
export function buyClass(data) {
  return request({
    url: "/ework2/weike/classGroup/buyClass",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: data,
  });
}
// 班级缴费
export function schoolClassPayFees(data) {
  return request({
    url: "/ework2/weike/schoolClass/schoolClassPayFees",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: data,
  });
}

export function classPayList(params) {
  return request({
    url: "/ework2/weike/classGroup/classPayList",
    method: "get",
    params,
  });
}

export function classPayDetail(params) {
  return request({
    url: "/ework2/weike/classGroup/classPayDetail",
    method: "get",
    params,
  });
}
export function getArchive(data) {
  return request({
    url: "/ework2/weike/student/archive",
    method: "post",
    data: data,
  });
}
export function faceMatch(data) {
  return request({
    url: "/ework2/weike/student/faceMatch",
    method: "post",
    data: data,
  });
}

// 证书查询
export function queryCertificate(params) {
  return request({
    url: "/ework2/weike/certificate/queryCertificate",
    method: "get",
    params,
  });
}

// 记录小节时长
export function uploadSectionProgress(params) {
  return request({
    url: "/ework2/weike/weikeClass/uploadSectionProgress",
    method: "get",
    params,
  });
}
export function myClassGroupInfo(params) {
  return request({
    url: `/ework2/weike/classGroup/myClassGroupInfo/${params.classGroupId}`,
    method: "get",
    params,
  });
}
export function getMyCertificate(params) {
  return request({
    url: `/ework2/weike/certificate/getMyCertificate`,
    method: "get",
    params,
  });
}
export function mySchoolClass(params) {
  return request({
    url: `/ework2/weike/schoolClass/mySchoolClass`,
    method: "get",
    params,
  });
}

// 获取订单列表
export function getOrderList(data) {
  return request({
    url: `/ework2/weike/classPay/pageList`,
    method: "post",
    data: data,
  });
}
// 申请开票
export function applyInvoice(data, classPayId) {
  return request({
    url: `/ework2/weike/classPay/applyInvoice/${classPayId}`,
    method: "post",
    data: data,
  });
}

// 申请退款
export function applyRefund(data, classPayId) {
  return request({
    url: `/ework2/weike/classPay/applyRefund//${classPayId}`,
    method: "post",
    data: data,
  });
}

// 保存证书下载记录
export function saveCertificateDownload(data) {
  return request({
    url: `/ework2/weike/certificate/saveCertificateDownloadRecord`,
    method: "post",
    data: data,
  });
}

// 获取证书记录
export function getCertificateRecord(data) {
  return request({
    url: `/ework2/weike/certificate/getCertificateDownloadRecord`,
    method: "post",
    data: data,
  });
}
export function getCertificateByCiphertext(params) {
  return request({
    url: `/ework2/weike/certificate/getCertificateByCiphertext`,
    method: "get",
    params,
  });
}
// 分页获取线下培训认证列表
export function offlineRecognitionList(params) {
  return request({
    url: `/ework2/weike/offlineRecognition/pageList`,
    method: "get",
    params,
  });
}
// 添加线下培训认证
export function offlineRecognitionAdd(data) {
  return request({
    url: `/ework2/weike/offlineRecognition/add`,
    method: "post",
    data: data,
  });
}
// 更新线下培训认证
export function offlineRecognitionUpdate(data) {
  return request({
    url: `/ework2/weike/offlineRecognition/update/${data.id}`,
    method: "post",
    data: data,
  });
}
// 撤回线下培训认证
export function offlineRecognitionWithdraw(data) {
  return request({
    url: `/ework2/weike/offlineRecognition/withdraw/${data.id}`,
    method: "post",
    data: data,
  });
}
export function offlineRecognitionDelete(data) {
  return request({
    url: `/ework2/weike/offlineRecognition/delete/${data.id}`,
    method: "post",
    data: data,
  });
}
// 学员培训记录
export function getSchoolClassLearnRecord(params) {
  return request({
    url: `/ework2/weike/student/getSchoolClassLearnRecord`,
    method: "get",
    params,
  });
}
// 获取考试题目
export function generateExamQuestion(params) {
  return request({
    url: `/ework2/exam/examinationPaper/generateExamQuestion/${params.classGroupId}`,
    method: "get",
    params,
  });
}


